import { createContext, useContext, useState, ReactNode } from "react";

interface NavigationData {
  wasErrorsFixed?: boolean;
  showSuccessToast?: boolean;
  savedMovements?: number;
  movementsWithErrors?: number;
}

interface NavigationDataContextProps {
  navigationData: NavigationData;
  setNavigationData: (data: NavigationData) => void;
  clearNavigationData: () => void;
}

const NavigationDataContext = createContext<NavigationDataContextProps | undefined>(undefined);

export const NavigationDataProvider = ({ children }: { children: ReactNode }) => {
  const [navigationData, setNavigationData] = useState<NavigationData>({});
  const clearNavigationData = () => setNavigationData({});
  return (
    <NavigationDataContext.Provider value={{ navigationData, setNavigationData, clearNavigationData }}>
      {children}
    </NavigationDataContext.Provider>
  );
};

export const useNavigationData = () => {
  const context = useContext(NavigationDataContext);
  if (!context) {
    throw new Error("useNavigationData must be used into <NavigationDataProvider>");
  }
  return context;
};
